<template>
    <contentCardIndex >
        <template slot="cardContent">
                <v-row align="center">
                    <v-col cols="12" md="3" lg="3" class="mx-0 px-0">
                        <alternativeTextField2
                            @onChanged="(v) => {trySearch(v);}" 
                            :valueInput="tableProps.search"
                            :rule="[]"
                            :placeholder="'Buscar'"
                            :label="''"
                            :prependInnerIcon="'mdi-magnify'"
                            class="pick-3"
                            data-cy="search-input"
                        ></alternativeTextField2>
                    </v-col>
                    <v-spacer></v-spacer>
                    
                </v-row>
                <v-row class="mt-md-0">
                    <v-col class="mx-0 px-0">
                        <datatable data-cy="index-table" :props="tableProps" @methodHandler="method_handler">
                        
                        </datatable>
                    </v-col>
                </v-row>
                <modal data-cy="index-modal" :props="modalProps" @modalResponse="method_handler">
                    <!-- Buttons -->
                    <template slot="cardActions">
                        <v-row justify="end" data-cy="index-modal-actions">
                            <v-col cols="12" sm="4">
                                <secondaryButton
                                data-cy="cancel-modal-btn"
                                :props="cancelModal"
                                ></secondaryButton>
                            </v-col>
                            <v-col cols="12" sm="4">
                                <primaryButton
                                data-cy="accept-modal-btn"
                                :props="acceptModal"
                                ></primaryButton>
                            </v-col>
                        </v-row>
                    </template> 
                </modal>
        </template>

        
    
    </contentCardIndex>

        
</template>
<script>
import Utils from '../../../helpers/Utils'
export default {
    data(){
		return {
           
           
			search: '',
            selectedID: '',
			actions: [
               
				{
					name: 'Detalles',
					icon: {
						color: 'primary',
						icon: 'mdi-information-outline',
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "details-link"
				},
                {
					name: 'Editar',
					icon: {
						color: 'primary',
						icon: 'mdi-pencil-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "edit-link"
				},
               
				{
					name: 'Borrar',
					icon: {
						color: 'primary',
						icon: 'mdi-delete-outline',
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'deleteItemModal',
                    permissions: 'products.delete',
                    dataCy: "delete-link"
				},

                {
					name: 'Seguimiento',
					icon: {
						color: 'primary',
						icon: 'mdi-clipboard-text-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "tracing-link"
				},

                {
					name: 'Registrar pago',
					icon: {
						color: 'primary',
						icon: 'mdi-credit-card-outline'
					},
					disabled: false,
					type: 'redirect',   //  method, external, redirect
					action: '',
                    permissions: 'products.edit',
                    dataCy: "payment-link"
				},

                {
					name: 'Imprimir',
					icon: {
						color: 'primary',
						icon: 'mdi-printer-outline'
					},
					disabled: false,
					type: 'method',   //  method, external, redirect
					action: 'getPdf',
                    permissions: 'products.delete',
                    dataCy: "pdf-link",
                    loading: false
				},
			],
			tableProps: {
				headers: [
                    {
						text: 'Folio',
						align: 'left break-words',
						value: 'folio',
                        width: "9%",
						class: 'table-b-border black--text'
					},
                    {
						text: 'Descripción',
						align: 'center break-words',
						value: 'work.name',
                        width: '25%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Cliente',
						align: 'center break-words',
						value: 'client.name',
                        width: '25%',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Subtotal',
						align: 'center break-words',
						value: 'subtotal',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Iva',
						align: 'center break-words',
						value: 'iva',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Total',
						align: 'center break-words',
						value: 'total',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Pagado',
						align: 'center break-words',
						value: 'paid',
						class: 'table-b-border black--text'
					},
                    {
						text: 'Saldo',
						align: 'center break-words',
						value: 'balance',
						class: 'table-b-border black--text'
					},
					{
						text: 'Acciones',
						align: 'right',
						sortable: false,
						value: 'actions',
						width: '15%',
						class: 'table-b-border black--text'
					}
				],
				items: [],
				search: '',
				loading: false
			},
			
			
         

			modalProps: {
				visible: false,
				width: '500',
				title: 'Eliminar',
				text: '¿Estás seguro de eliminar?',
				loading: false,
				bottomLineColor: 'error',
				
			},
			
			cancelModal: {
                text: "No, cancelar",
                icon: "",
				to: "",
				block: true,
				color: '',
                cy:"cancel-modal-btn",
                click: ()=>{this.modalProps.visible = false}
            },
			acceptModal: {
                text: "SI, ELIMINAR",
                icon: "",
				to: "",
				block: true,
				color: 'error',
				textColor:'white',
                textColorLevel: '0',
				loading:false,
                cy:"accept-modal-btn",
                click: ()=>{this.delete()}
            },
		}
	},

	mounted(){
		this.index();
        window.addEventListener('resize', this.onResize, { passive: true });
        this.onResize();
	},

    methods: {
        method_handler(object){
			this[object.methodName](object.parameters)
		},
        onResize () {
            
            // if(window.innerWidth < 960){
            //     this.createBtnData.block = true;
                
            // }
            // else{
            //     this.createBtnData.block = false;
                
            // }
        },
      
        trySearch(val){
            this.tableProps.search = val;
        },
		index() {
			this.tableProps.loading = true;
           
			// call api
			this.$api.saleOrder.list()
				.then((resp) =>{
					//console.log(resp);
					this.tableProps.items = resp.data.reverse().map((x,i) => {
						x['actions'] = JSON.parse(JSON.stringify(this.actions))
                       
						
                        x.actions[0].action = { name: 'SaleOrdersDetails', params: { saleOrderId: x.id } }
                        x.actions[1].action = { name: 'SaleOrdersEdit', params: { id: x.id } }
                        x.actions[3].action = { name: 'SaleOrdersCreateTracing', params: { saleOrderId: x.id } }
                        x.actions[4].action = { name: 'SaleOrdersCreatePayment', params: { saleOrderId: x.id } }
						

						x['parameters'] = { id: x.id, name: x.folio, index: i};
                        const total = parseFloat(x.subtotal) + parseFloat(x.iva);
                        const balance = parseFloat(total - x.paid).toFixed(2);
                        if(balance <= 0){
                            x.actions[4].disabled = true
                        }
                        x.subtotal = Utils.currencyFormat(x?.subtotal??"", "");
                        x.iva = Utils.currencyFormat(x?.iva??"", "");
                        x.total = Utils.currencyFormat(total, "");
                        x.balance = Utils.currencyFormat(balance, "");
                        x.paid = Utils.currencyFormat(x.paid, "");
                       
						return x;
					});
				})
				.catch((error) =>{
					console.log(error);
				})
				.finally(() => {
					this.tableProps.loading = false;
				})
			;
		
		},



		deleteItemModal(parameters)
		{
			//console.log(parameters);
			this.selectedID = parameters.id;
			this.modalProps = {
				...this.modalProps,
				text: `¿Estás seguro de eliminar "${parameters.name}"?`,
				
			}
            console.log(this.selectedID)
			this.modalProps.visible = true;
			
		},


		delete()
		{
			//console.log(this.selectedID);
			this.acceptModal.loading = true;
			this.$api.saleOrder.delete(this.selectedID)
			// eslint-disable-next-line
			.then((response) => {
				
				this.$store.dispatch('snackbarSuccess', `Se ha eliminado`);
				this.index()
				// eslint-disable-next-line
			}).catch(error => {
				if(error.response.status === 422){
                    this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al eliminar'}`);
                }else{
                    this.$store.dispatch('snackbarError', `Error al eliminar. Intenta de nuevo`);
                }

				
			})
			.finally(() => {
				this.modalProps.visible = false;
				this.acceptModal.loading = false;
			})
		},


        getPdf(parameters)
		{
            this.selectedID = parameters.id;
            this.tableProps.items[parameters.index].actions[5].loading = true
			//console.log(this.selectedID);
			this.$api.saleOrder.pdf(this.selectedID)
                // eslint-disable-next-line
                .then((response) => {
                    console.log(response);
                    let file = new Blob([response.data], {type: 'application/pdf'});
                    let fileURL = URL.createObjectURL(file);
                    window.open(fileURL);
                    // eslint-disable-next-line
                }).catch(error => {
                    if(error.response.status === 422){
                        this.$store.dispatch('snackbarError', `${error.response.data.error??'Error al obtener archivo'}`);
                    }else{
                        this.$store.dispatch('snackbarError', `Error. Intenta de nuevo`);
                    }

                    
                })
                .finally(() => {
                    this.tableProps.items[parameters.index].actions[5].loading = false;
                })
            ;
		},

    }
}
</script>